import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

// Панель разбора грузится на переходе — не тянем её в стартовый бандл.
const CallDetail = lazyRouteComponent(() => import('@/widgets/call-detail'), 'CallDetail')

export const Route = createFileRoute('/calls/$callId')({
  component: CallPage,
})

function CallPage() {
  const { callId } = Route.useParams()
  return (
    <>
      <Breadcrumbs current={callId} />
      <CallDetail callId={callId} />
    </>
  )
}
